import { render, staticRenderFns } from "./UpdateRecords.vue?vue&type=template&id=9a519f06&scoped=true&"
import script from "./UpdateRecords.vue?vue&type=script&lang=js&"
export * from "./UpdateRecords.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRecords.vue?vue&type=style&index=0&id=9a519f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a519f06",
  null
  
)

export default component.exports